export default __webpack_public_path__ + "static/media/odoticon.d4a3d98b.png";